export const isArray = <T>(value: unknown): value is Array<T> => {
  if (value && Array.isArray(value)) {
    return true
  }

  return false
}
